(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ec-pack-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ec-pack-picker')) {
    customElements.define(
      'ec-pack-picker',
      class extends HTMLElement {
        connectedCallback() {
          this.total = this.querySelector('[data-total]');
          this.perDay = this.querySelector('[data-per-day]');
          this.stock = this.querySelector('[data-stock]');
          this.stockText = this.querySelector('[data-stock-text]');
          this.submit = this.querySelector('[data-submit]');
          this.qty = this.querySelector('input[name="quantity"]');
          this.inStockText = this.stockText ? this.stockText.textContent : '';
          this.buttonText = this.submit ? this.submit.textContent : '';

          this.querySelectorAll('.ec-pp__radio').forEach((radio) =>
            radio.addEventListener('change', () => this.update(radio))
          );
          const minus = this.querySelector('[data-minus]');
          const plus = this.querySelector('[data-plus]');
          if (minus) minus.addEventListener('click', () => this.step(-1));
          if (plus) plus.addEventListener('click', () => this.step(1));
        }
        step(delta) {
          const v = Math.max(1, (parseInt(this.qty.value, 10) || 1) + delta);
          this.qty.value = v;
        }
        update(radio) {
          if (this.total) this.total.textContent = radio.dataset.price;
          if (this.perDay) this.perDay.textContent = radio.dataset.perDay;
          const available = radio.dataset.available === 'true';
          if (this.submit) {
            this.submit.disabled = !available;
            this.submit.textContent = available ? this.buttonText : 'Vyprodáno';
          }
          if (this.stock) {
            this.stock.classList.toggle('is-out', !available);
            this.stockText.textContent = available ? this.inStockText : 'Momentálně vyprodáno';
          }
          const url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          window.history.replaceState({}, '', url.toString());
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
